import React, { useEffect, useRef, useState } from "react";
import Layout from "../Layout/Layout.js";
import { APIUrl } from "../../Helper/APIUrl.js";
import { useSnackbar } from "notistack";
import { useSearchParams } from "react-router-dom";
import DataTable from "react-data-table-component";

function Meta() {
  const Token = JSON.parse(localStorage.getItem("tcn"));
  const localStorageUserId = JSON.parse(localStorage.getItem("userid"));
  const { enqueueSnackbar } = useSnackbar();

  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");

  const [ddlPageURLMaster, setddlPageURLMaster] = useState([]);

  const [edit, setEdit] = useState(false);

  const [MetaId, setMetaId] = useState(0);
  const [URLId, setURLId] = useState(0);
  const [Title, setTitle] = useState("");
  const [Description, setDescription] = useState("");
  const [Keyword, setKeyword] = useState("");
  const [IsActive, setIsActive] = useState(true);
  const [CreatedBy] = useState(localStorageUserId || 0);

  const [State, setState] = useState("");
  const [City, setCity] = useState("");
  const [Area, setArea] = useState("");
  const [PropertyTypeName, setPropertyTypeName] = useState("");
  const [PageURL, setPageURL] = useState("");

  const [search, setsearch] = useState("");
  const [lstMeta, setlstMeta] = useState([]);
  const [filterMeta, setfilterMeta] = useState([]);

  const pageURLSelectRef = useRef(null);
  const TitleRef = useRef(null);
  const DescriptionRef = useRef(null);
  const KeywordRef = useRef(null);

  const coloumn = [
    {
      name: "SNo.",
      selector: (row, index) => index + 1,
      maxWidth: "70px",
    },
    {
      name: "Page URL",
      selector: (row) =>
        `${row.PageURL || ""} ${row.State || ""} ${row.City || ""}`,
      sortable: true,
      grow: 2,
      wrap: true,
      cell: (row) => (
        <div className="py-2">
          <p className="text-sm font-semibold text-slate-800 break-words whitespace-normal">
            {row.PageURL || "-"}
          </p>
          <p className="text-xs text-slate-600 break-words whitespace-normal mt-1">
            {row.State || "-"} | {row.City || "-"} |{" "}
            {row.PropertyTypeName || "-"}
          </p>
        </div>
      ),
    },
    {
      name: "Meta Details",
      selector: (row) =>
        `${row.Title || ""} ${row.Description || ""} ${row.Keyword || ""}`,
      sortable: true,
      grow: 3,
      wrap: true,
      cell: (row) => (
        <div className="py-2">
          <p className="text-sm font-semibold text-slate-800 break-words whitespace-normal">
            {row.Title || "-"}
          </p>
          <p className="text-xs text-slate-600 break-words whitespace-normal mt-1">
            {row.Description || "-"}
          </p>
          <p className="text-xs text-slate-700 break-words whitespace-normal mt-1">
            <span className="font-semibold">Keyword:</span> {row.Keyword || "-"}
          </p>
        </div>
      ),
    },
    {
      name: "Status",
      cell: (row) =>
        row.IsActive ? (
          <label className="inline-flex px-2 py-1 text-xs font-semibold rounded-full bg-green-100 text-green-800">
            Activated
          </label>
        ) : (
          <label className="inline-flex px-2 py-1 text-xs font-semibold rounded-full bg-red-100 text-red-800">
            Deactivated
          </label>
        ),
      grow: 1,
    },
    {
      name: "Action",
      grow: 1,
      cell: (row) => (
        <div className="flex items-center gap-2 py-2">
          <button
            type="button"
            onClick={() => handleEditMeta(row)}
            className="text-white bg-gradient-to-r from-sky-500 to-blue-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-sky-200 font-medium rounded-lg text-sm px-3 py-2"
            title="Edit Meta"
          >
            <i className="fa fa-pencil" aria-hidden="true"></i>
          </button>
          {row.IsActive ? (
            <button
              type="button"
              onClick={() => activateDeactiveMeta(row.MetaId, "deactivate")}
              className="text-white bg-gradient-to-r from-green-500 to-emerald-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-green-200 font-medium rounded-lg text-sm px-3 py-2"
              title="Deactivate Meta"
            >
              <i className="fa fa-toggle-on" aria-hidden="true"></i>
            </button>
          ) : (
            <button
              type="button"
              onClick={() => activateDeactiveMeta(row.MetaId, "activate")}
              className="text-white bg-gradient-to-r from-red-500 to-rose-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-red-200 font-medium rounded-lg text-sm px-3 py-2"
              title="Activate Meta"
            >
              <i className="fa fa-toggle-off" aria-hidden="true"></i>
            </button>
          )}
        </div>
      ),
    },
  ];

  useEffect(() => {
    getddlPageURLMaster();
    getAllMeta();
  }, []);

  useEffect(() => {
    const query = (search || "").toLowerCase();

    const result = lstMeta.filter((x) => {
      const searchableValues = [
        x?.Title,
        x?.Description,
        x?.Keyword,
        x?.PageURL,
        x?.State,
        x?.City,
        x?.PropertyTypeName,
      ];

      return searchableValues.some((value) =>
        String(value || "")
          .toLowerCase()
          .includes(query),
      );
    });

    setfilterMeta(result);
  }, [search, lstMeta]);

  useEffect(() => {
    if (!id || isNaN(id) || ddlPageURLMaster.length === 0) {
      return;
    }

    handleDDLChange(id);
  }, [id, ddlPageURLMaster]);

  const parseJSON = async (response) => {
    try {
      const text = await response.text();
      if (!text) return null;
      return JSON.parse(text);
    } catch (err) {
      console.warn("Failed to parse JSON response", err);
      return null;
    }
  };

  const getddlPageURLMaster = async () => {
    try {
      const response = await fetch(
        APIUrl.PageURLMaster + "GetAllPageURLMaster",
        {
          method: "Post",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Token}`,
          },
          body: JSON.stringify(),
        },
      );

      const result = await parseJSON(response);

      if (result?.Message === "Success") {
        setddlPageURLMaster(Array.isArray(result.data) ? result.data : []);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const normalizeMetaList = (list) => {
    const mapper = new Map();

    (list || []).forEach((item) => {
      const key = Number(item?.URLId || 0);
      const existing = mapper.get(key);

      if (
        !existing ||
        Number(item?.MetaId || 0) > Number(existing?.MetaId || 0)
      ) {
        mapper.set(key, item);
      }
    });

    return Array.from(mapper.values());
  };

  const getAllMeta = async () => {
    try {
      const response = await fetch(APIUrl.Meta + "GetAllMeta", {
        method: "Post",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Token}`,
        },
        body: JSON.stringify(),
      });

      const result = await parseJSON(response);

      if (result?.Message === "Success" && Array.isArray(result.data)) {
        const normalizedList = normalizeMetaList(result.data);
        const id = searchParams.get("id");
        let FilteredbyUrlId = normalizedList.filter((x) => x.URLId == id);
        setlstMeta(FilteredbyUrlId);
        setfilterMeta(FilteredbyUrlId);
        return FilteredbyUrlId;
      }

      setlstMeta([]);
      setfilterMeta([]);
      return [];
    } catch (error) {
      console.log(error);
      setlstMeta([]);
      setfilterMeta([]);
      return [];
    }
  };

  const fnGetMyMetaByURLId = async (id) => {
    try {
      const response = await fetch(APIUrl.Meta + "GetMetaByURLId/" + id, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Token}`,
        },
      });

      const result = await parseJSON(response);
      if (result?.Message === "Success" && result.data) {
        const metaData = result.data;
        setMetaId(metaData.MetaId || 0);
        setTitle(metaData.Title || "");
        setDescription(metaData.Description || "");
        setKeyword(metaData.Keyword || "");
        setIsActive(metaData.IsActive ?? true);
        setEdit(true);
      } else {
        setMetaId(0);
        setTitle("");
        setDescription("");
        setKeyword("");
        setIsActive(true);
        setEdit(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleDDLChange = (selectedId) => {
    const normalizedURLId = Number(selectedId || 0);
    const filterPageURLMaster = ddlPageURLMaster.find(
      (x) => Number(x.URLId) === normalizedURLId,
    );

    if (filterPageURLMaster) {
      setState(filterPageURLMaster.State || "");
      setCity(filterPageURLMaster.City || "");
      setArea(filterPageURLMaster.AreaName || filterPageURLMaster.Area || "");
      setPageURL(filterPageURLMaster.PageURL || "");
      setPropertyTypeName(filterPageURLMaster.PropertyTypeName || "");
      setURLId(filterPageURLMaster.URLId || 0);
      fnGetMyMetaByURLId(filterPageURLMaster.URLId);
    } else {
      setState("");
      setCity("");
      setArea("");
      setPageURL("");
      setPropertyTypeName("");
      setURLId(0);
      setMetaId(0);
      setTitle("");
      setDescription("");
      setKeyword("");
      setIsActive(true);
      setEdit(false);
    }

    if (normalizedURLId === 0) {
      resetForm();
    }
  };

  async function activateDeactiveMeta(Id, Value) {
    try {
      const data = { Value };
      const response = await fetch(
        APIUrl.Meta + "ActivateDeactivateMeta/" + Id,
        {
          method: "Post",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Token}`,
          },
          body: JSON.stringify(data),
        },
      );

      const result = await parseJSON(response);
      if (result) {
        await getAllMeta();
        Value === "activate"
          ? enqueueSnackbar("Successfully Activated", { variant: "success" })
          : enqueueSnackbar("Successfully Deactivated", { variant: "warning" });
      }
    } catch (error) {
      console.log(error);
      enqueueSnackbar("Failed to update Meta status.", { variant: "error" });
    }
  }

  function handleEditMeta(row) {
    if (!row?.URLId) {
      enqueueSnackbar("URLId not found for selected Meta.", {
        variant: "warning",
      });
      return;
    }

    handleDDLChange(row.URLId);
    setEdit(true);
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  const resetForm = () => {
    setMetaId(0);
    setURLId(0);
    setTitle("");
    setDescription("");
    setKeyword("");
    setIsActive(true);
    setState("");
    setCity("");
    setArea("");
    setPropertyTypeName("");
    setPageURL("");
    setEdit(false);
  };

  const validateAndSaveMeta = async () => {
    const validations = [
      { isInvalid: !Token, message: "Please login first." },
      {
        isInvalid: !URLId,
        message: "Please Select Page URL.",
        focus: () => pageURLSelectRef.current?.focus(),
      },
      {
        isInvalid: !State.trim(),
        message: "State is required.",
        focus: () => pageURLSelectRef.current?.focus(),
      },
      {
        isInvalid: !City.trim(),
        message: "City is required.",
        focus: () => pageURLSelectRef.current?.focus(),
      },
      {
        isInvalid: !PropertyTypeName.trim(),
        message: "Property Type is required.",
        focus: () => pageURLSelectRef.current?.focus(),
      },
      {
        isInvalid: !PageURL.trim(),
        message: "Master Page URL is required.",
        focus: () => pageURLSelectRef.current?.focus(),
      },
      {
        isInvalid: !Title.trim(),
        message: "Title is required.",
        focus: () => TitleRef.current?.focus(),
      },
      {
        isInvalid: !Description.trim(),
        message: "Description is required.",
        focus: () => DescriptionRef.current?.focus(),
      },
      {
        isInvalid: !Keyword.trim(),
        message: "Keyword is required.",
        focus: () => KeywordRef.current?.focus(),
      },
    ];

    const failedValidation = validations.find((item) => item.isInvalid);
    if (failedValidation) {
      enqueueSnackbar(failedValidation.message, { variant: "warning" });
      failedValidation.focus?.();
      return;
    }

    try {
      const data = {
        MetaId,
        URLId,
        Title: Title.trim(),
        Description: Description.trim(),
        Keyword: Keyword.trim(),
        IsActive,
        CreatedBy,
      };

      const response = await fetch(APIUrl.Meta + "UpdateMeta/" + MetaId, {
        method: "Post",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Token}`,
        },
        body: JSON.stringify(data),
      });

      const result = await parseJSON(response);

      if (
        result?.Message === "Success" ||
        result?.returnID > 0 ||
        response.ok
      ) {
        enqueueSnackbar(
          result?.Message ||
            (edit ? "Successfully Updated" : "Successfully Saved"),
          { variant: "success" },
        );

        await getAllMeta();
        await fnGetMyMetaByURLId(URLId);
        setEdit(true);
        return;
      }

      enqueueSnackbar(result?.Message || "Failed to save Meta.", {
        variant: "error",
      });
    } catch (error) {
      console.log(error);
      enqueueSnackbar(error?.message || "Error while saving Meta.", {
        variant: "error",
      });
    }
  };

  return (
    <Layout>
      <main className="flex-1 overflow-y-auto p-4 sm:p-6 lg:p-8 bg-slate-50">
        <div className="mx-auto w-full max-w-[1500px] rounded-xl border border-slate-200 bg-white shadow-sm">
          <div className="flex flex-col gap-3 border-b border-slate-200 p-4 sm:p-5 md:flex-row md:items-center md:justify-between">
            <div>
              <h1 className="text-xl font-semibold text-slate-900">Meta</h1>
              <p className="mt-1 text-sm text-slate-600"></p>
            </div>
            <button
              type="button"
              onClick={() => window.location.assign("/pageurlmaster")}
              className="rounded-md bg-indigo-600 px-4 py-2 text-xs font-semibold text-white shadow-sm transition hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-400 focus:ring-offset-2"
            >
              Back to Page URL Master
            </button>
          </div>

          <div className="grid grid-cols-1 gap-4 md:grid-cols-2 border-b border-slate-200 p-4 sm:p-5">
            <select
              ref={pageURLSelectRef}
              value={URLId}
              onChange={(e) => handleDDLChange(e.target.value)}
              disabled
              className="w-full rounded-md border border-slate-300 bg-slate-100 px-3 py-2 text-sm text-slate-700 outline-none transition focus:border-indigo-400 focus:bg-white focus:ring-2 focus:ring-indigo-100"
            >
              <option value={0}>Select Page URL</option>
              {ddlPageURLMaster.map((item) => (
                <option key={item.URLId} value={item.URLId}>
                  {item.PageURL}
                </option>
              ))}
            </select>
          </div>

          <div className="space-y-4 p-4 sm:p-5">
            <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
              <div>
                <label className="mb-1.5 block text-xs font-semibold text-slate-600">
                  State
                </label>
                <input
                  type="text"
                  className="w-full rounded-md border border-slate-300 bg-slate-100 px-3 py-2 text-sm text-slate-700 outline-none transition focus:border-indigo-400 focus:bg-white focus:ring-2 focus:ring-indigo-100"
                  value={State}
                  disabled={true}
                />
              </div>
              <div>
                <label className="mb-1.5 block text-xs font-semibold text-slate-600">
                  City
                </label>
                <input
                  type="text"
                  className="w-full rounded-md border border-slate-300 bg-slate-100 px-3 py-2 text-sm text-slate-700 outline-none transition focus:border-indigo-400 focus:bg-white focus:ring-2 focus:ring-indigo-100"
                  value={City}
                  disabled={true}
                />
              </div>
              <div>
                <label className="mb-1.5 block text-xs font-semibold text-slate-600">
                  Area
                </label>
                <input
                  type="text"
                  className="w-full rounded-md border border-slate-300 bg-slate-100 px-3 py-2 text-sm text-slate-700 outline-none transition focus:border-indigo-400 focus:bg-white focus:ring-2 focus:ring-indigo-100"
                  value={Area}
                  disabled={true}
                />
              </div>
            </div>
            <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
              <div>
                <label className="mb-1.5 block text-xs font-semibold text-slate-600">
                  Property Type
                </label>
                <input
                  type="text"
                  className="w-full rounded-md border border-slate-300 bg-slate-100 px-3 py-2 text-sm text-slate-700 outline-none transition focus:border-indigo-400 focus:bg-white focus:ring-2 focus:ring-indigo-100"
                  value={PropertyTypeName}
                  disabled={true}
                />
              </div>
              <div>
                <label className="mb-1.5 block text-xs font-semibold text-slate-600">
                  Master Page URL
                </label>
                <input
                  type="text"
                  className="w-full rounded-md border border-slate-300 bg-slate-100 px-3 py-2 text-sm text-slate-700 outline-none transition focus:border-indigo-400 focus:bg-white focus:ring-2 focus:ring-indigo-100"
                  value={PageURL}
                  disabled={true}
                />
              </div>
            </div>

            <div>
              <label className="mb-1.5 block text-xs font-semibold text-slate-600">
                Title
              </label>
              <textarea
                ref={TitleRef}
                rows={2}
                className="w-full rounded-md border border-slate-300 px-3 py-2 text-sm text-slate-700 outline-none transition focus:border-indigo-400 focus:bg-white focus:ring-2 focus:ring-indigo-100"
                value={Title}
                onChange={(e) => setTitle(e.target.value)}
              />
            </div>

            <div>
              <label className="mb-1.5 block text-xs font-semibold text-slate-600">
                Description
              </label>
              <textarea
                ref={DescriptionRef}
                rows={4}
                className="w-full rounded-md border border-slate-300 px-3 py-2 text-sm text-slate-700 outline-none transition focus:border-indigo-400 focus:bg-white focus:ring-2 focus:ring-indigo-100"
                value={Description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </div>

            <div>
              <label className="mb-1.5 block text-xs font-semibold text-slate-600">
                Keyword
              </label>
              <textarea
                ref={KeywordRef}
                rows={2}
                className="w-full rounded-md border border-slate-300 px-3 py-2 text-sm text-slate-700 outline-none transition focus:border-indigo-400 focus:bg-white focus:ring-2 focus:ring-indigo-100"
                value={Keyword}
                onChange={(e) => setKeyword(e.target.value)}
              />
            </div>

            <div className="flex flex-wrap items-center gap-2 pt-2">
              <button
                type="button"
                onClick={validateAndSaveMeta}
                className="rounded-md bg-blue-600 px-4 py-2 text-xs font-semibold text-white shadow-sm transition hover:bg-blue-700"
              >
                {edit ? "Update" : "Save"}
              </button>
            </div>
          </div>
        </div>

        {/* <div className="mt-6 rounded-xl border border-slate-200 bg-white shadow-sm overflow-hidden">
                    <div className="overflow-x-auto">
                        <DataTable
                            title="Manage Meta"
                            columns={coloumn}
                            data={filterMeta}
                            pagination
                            fixedHeader
                            fixedHeaderScrollHeight="500px"
                            highlightOnHover
                            subHeader
                            subHeaderAlign="right"
                            subHeaderComponent={
                                <input
                                    type="text"
                                    placeholder="Search Meta"
                                    className="w-full sm:w-72 rounded-lg border border-slate-300 px-4 py-2 text-sm focus:border-indigo-400 focus:outline-none focus:ring-2 focus:ring-indigo-100"
                                    value={search}
                                    onChange={(e) => setsearch(e.target.value)}
                                />
                            }
                        />
                    </div>
                </div> */}
      </main>
    </Layout>
  );
}

export default Meta;
